import { i18n } from '@lingui/core'
import { t } from '@lingui/macro'
import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { PdfSplittableTableRow } from 'app/views/forms/pdf-components/PdfSplittableTableRow'
import { PdfTableCell } from 'app/views/forms/pdf-components/PdfTableCell'
import { PdfTableHeaderCell } from 'app/views/forms/pdf-components/PdfTableHeaderCell'
import { pdfTableStyles } from 'app/views/forms/pdf-components/PdfTableStyles'
import { PdfUnsplittableTableRow } from 'app/views/forms/pdf-components/PdfUnsplittableTableRow'
import React from 'react'

const styles = StyleSheet.create({
  objectiveCol: {
    width: '25%',
    fontWeight: 'bold'
  },
  col: {
    width: '25%'
  }
})

interface ObjectivesUpdate {
  identifiedNeedChanges?: string
  desiredOutcomeChanges?: string
  actualOutcomes?: string
}

interface ObjectiveWithUpdate {
  /** Objective key, translated for display */
  objective: string
  objectivesUpdate?: ObjectivesUpdate
}

interface FormObjectivesUpdatePdfProps {
  title?: string
  value?: ObjectiveWithUpdate[]
}

export const FormObjectivesUpdatePdf = ({
  title,
  value = []
}: FormObjectivesUpdatePdfProps): React.ReactElement => (
  <View style={pdfTableStyles.table}>
    {title ? (
      <Text style={[pdfTableStyles.title, pdfTableStyles.tableCol]}>{title}</Text>
    ) : (
      <View />
    )}
    <PdfUnsplittableTableRow>
      <PdfTableHeaderCell style={styles.objectiveCol}>{i18n._(t`Objective`)}</PdfTableHeaderCell>
      <PdfTableHeaderCell style={styles.col}>
        {i18n._(t`FORM_OBJECTIVES_UPDATE_IDENTIFIED_NEEDS_CHANGES`)}
      </PdfTableHeaderCell>
      <PdfTableHeaderCell style={styles.col}>
        {i18n._(t`FORM_OBJECTIVES_UPDATE_DESIRED_OUTCOME_CHANGES`)}
      </PdfTableHeaderCell>
      <PdfTableHeaderCell style={styles.col}>
        {i18n._(t`FORM_OBJECTIVES_UPDATE_ACTUAL_OUTCOMES`)}
      </PdfTableHeaderCell>
    </PdfUnsplittableTableRow>
    {value.map((item, index) => (
      <PdfSplittableTableRow key={index}>
        <PdfTableCell style={styles.objectiveCol}>
          <Text>{i18n._(item.objective)}</Text>
        </PdfTableCell>
        <PdfTableCell style={styles.col}>
          <Text>{item.objectivesUpdate?.identifiedNeedChanges || ''}</Text>
        </PdfTableCell>
        <PdfTableCell style={styles.col}>
          <Text>{item.objectivesUpdate?.desiredOutcomeChanges || ''}</Text>
        </PdfTableCell>
        <PdfTableCell style={styles.col}>
          <Text>{item.objectivesUpdate?.actualOutcomes || ''}</Text>
        </PdfTableCell>
      </PdfSplittableTableRow>
    ))}
  </View>
)
